import React from "react";
import HeaderInner from "../header/HeaderInner";
import ProjectDetails from "./breadcrumb/ProjectDetails";
import Footer from "../elements/Footer";
import { Link } from "react-router-dom";

// DATA
import { DataProject } from "../data/DataProject";

function PortfolioSix({ id }) {
  const project = DataProject.items.find((item) => item.id === id);

  return (
    <div>
      <HeaderInner />
      <>
        <ProjectDetails title={project.title} />

        {/* Start Projects Details area  */}
        <div className="projects-details-area tmp-section-gap">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="projects-details-inner">
                  <div className="thumbnail position-relative">
                    <img
                      style={{ width: "1290px", height: "600px" }}
                      src={project.img}
                      alt="projects-details"
                    />
                  </div>
                  <div className="clients-projects-details">
                    <div className="clients-details-inner">
                      <h3 className="title text-center">
                        {project.title.toUpperCase()}
                      </h3>
                      <div className="single-projects-details">
                        <div className="info">
                          <div className="icon">
                            <i className="fa-solid fa-user" />
                          </div>
                          <div className="content">
                            <h4 className="subtitle">Client:</h4>
                            <h5 className="category">{project.client}</h5>
                          </div>
                        </div>

                        <div className="info">
                          <div className="icon">
                            <i className="fa-light fa-calendar-days" />
                          </div>
                          <div className="content">
                            <h4 className="subtitle">Date:</h4>
                            <h5 className="category">{project.date}</h5>
                          </div>
                        </div>
                        <div className="info">
                          <div className="icon">
                            <i className="fa-regular fa-map-location" />
                          </div>
                          <div className="content">
                            <h4 className="subtitle">Délai:</h4>
                            <h5 className="category">{project.delay}</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="projects-details-wrapper">
                      <p className="description">{project.desc}</p>
                    </div>
                    <div className="projects-details-wrapper">
                      <div className="row">
                        {project.gallery.map((item) => {
                          return (
                            <div
                              className="col-lg-6 col-md-6 col-sm-12 col-12"
                              key={item.id}
                            >
                              <div className="thumbnail">
                                <img
                                  style={{ width: "520px", height: "370px" }}
                                  src={item.img}
                                  alt="gallery"
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Start Projects Details area  */}

        <Footer />
      </>
    </div>
  );
}

export default PortfolioSix;
